export enum eInternalOrderStatus {
  new = 'new',
  initial_docs_available = 'initial_docs_available',
  waiting_for_search = 'waiting_for_search',
  production = 'production',
  title_report_available = 'title_report_available',
  clearance = 'clearance',
  title_clear = 'title_clear',
  clear_to_close = 'clear_to_close',
  signing_scheduled = 'signing_scheduled',
  signing_confirmed = 'signing_confirmed',
  signing_occurred = 'signing_occurred',
  waiting_for_funds = 'waiting_for_funds',
  ready_to_disburse = 'ready_to_disburse',
  funded = 'funded',
  recorded = 'recorded',
  funded_and_recorded = 'funded_and_recorded',
  policy_issued = 'policy_issued',
  complete = 'complete',
  cancelled = 'cancelled',
  /* @Deprecated */
  closing = 'closing',
  /* @Deprecated */
  post_closing = 'post_closing',
}

export const prettyInternalOrderStatus: Record<eInternalOrderStatus, string> = {
  new: 'New',
  initial_docs_available: 'Initial Docs Available',
  waiting_for_search: 'Waiting For Search',
  production: 'Production',
  title_report_available: 'Title Report Available',
  clearance: 'Clearance',
  title_clear: 'Title Clear',
  clear_to_close: 'Clear To Close',
  signing_scheduled: 'Signing Scheduled',
  signing_confirmed: 'Signing Confirmed',
  signing_occurred: 'Signing Occurred',
  waiting_for_funds: 'Waiting For Funds',
  ready_to_disburse: 'Ready To Disburse',
  funded: 'Funded',
  recorded: 'Recorded',
  funded_and_recorded: 'Funded and Recorded',
  policy_issued: 'Policy Issued',
  complete: 'Complete',
  cancelled: 'Cancelled',
  /* @Deprecated */
  closing: 'Closing',
  /* @Deprecated */
  post_closing: 'Post Closing',
};
/*
Future ref: this code block can be removed after deprecated values are removed from eInternalOrderStatus
creating another set of enum without depricated values for pc dashboard.
*/
export enum eInternalOrderStatusWithoutDeprecatedValues {
  new = 'new',
  initial_docs_available = 'initial_docs_available',
  waiting_for_search = 'waiting_for_search',
  production = 'production',
  title_report_available = 'title_report_available',
  clearance = 'clearance',
  title_clear = 'title_clear',
  clear_to_close = 'clear_to_close',
  signing_scheduled = 'signing_scheduled',
  signing_confirmed = 'signing_confirmed',
  signing_occurred = 'signing_occurred',
  waiting_for_funds = 'waiting_for_funds',
  ready_to_disburse = 'ready_to_disburse',
  funded = 'funded',
  recorded = 'recorded',
  funded_and_recorded = 'funded_and_recorded',
  policy_issued = 'policy_issued',
  complete = 'complete',
  cancelled = 'cancelled',
}

export const prettyInternalOrderStatusWithoutDeprecatedValues: Record<
  eInternalOrderStatusWithoutDeprecatedValues,
  string
> = {
  new: 'New',
  initial_docs_available: 'Initial Docs Available',
  waiting_for_search: 'Waiting For Search',
  production: 'Production',
  title_report_available: 'Title Report Available',
  clearance: 'Clearance',
  title_clear: 'Title Clear',
  clear_to_close: 'Clear To Close',
  signing_scheduled: 'Signing Scheduled',
  signing_confirmed: 'Signing Confirmed',
  signing_occurred: 'Signing Occurred',
  waiting_for_funds: 'Waiting For Funds',
  ready_to_disburse: 'Ready To Disburse',
  funded: 'Funded',
  recorded: 'Recorded',
  funded_and_recorded: 'Funded and Recorded',
  policy_issued: 'Policy Issued',
  complete: 'Complete',
  cancelled: 'Cancelled',
};
